const getInitialValue = () => {
    return {
        starting: true,
        data: {},
        span: {}
    }
}

const WidgetReducer = (state = getInitialValue(), message) => {
    switch (message?.type) {
        case 'start':
            return { 
                ...state, starting: true, data: {}
            }
        case 'event':
            const events = message?.events
            return { 
                ...state, data: events 
            }
        case 'span':
            return { 
                ...state, span: { ...state.span, [message?.layer]: message.events } 
            }
    }
    return state
}

export default WidgetReducer